import { AxiosError, AxiosResponse } from 'axios';
import { useEffect, useState } from 'react';
import {
  SSO_REAUTH_DEADLINE_HEADER_KEY,
  isRequestFromCurrentSession,
  restApi,
} from '../../../services/api';

const readReauthDeadlineHeader = (
  headers: AxiosResponse['headers'] | undefined,
): string | undefined => {
  const value = headers?.[SSO_REAUTH_DEADLINE_HEADER_KEY];
  return typeof value === 'string' ? value : undefined;
};

const useSsoReauthDeadline = () => {
  const [reauthDeadline, setReauthDeadline] = useState<string>();

  useEffect(() => {
    const interceptorId = restApi.axiosInstance.interceptors.response.use(
      (response) => {
        if (isRequestFromCurrentSession(response.config)) {
          setReauthDeadline(readReauthDeadlineHeader(response.headers));
        }
        return response;
      },
      (error: AxiosError) => {
        if (error.response && isRequestFromCurrentSession(error.config)) {
          setReauthDeadline(readReauthDeadlineHeader(error.response.headers));
        }
        return Promise.reject(error);
      },
    );

    return () => restApi.axiosInstance.interceptors.response.eject(interceptorId);
  }, []);

  return reauthDeadline;
};

export default useSsoReauthDeadline;
